/**
 * Trading Hub API client — isolato dal client principale del gestionale.
 * Ha un proprio storage token (sessionStorage con chiave dedicata) e non
 * interferisce con axios instance del gestionale.
 */
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'th_token';

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: BASE });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken()) {
      clearToken();
      if (typeof window !== 'undefined') window.location.replace('/th-portal');
    }
    return Promise.reject(err);
  }
);

export default client;
